import { defineMessages } from 'react-intl';

const messages = defineMessages({
  message: {
    id: 'ServiceError.Message',
    defaultMessage: 'Service error, please try again',
  },
});

export default messages;
